module.exports = __webpack_public_path__ + "static/media/SarahSwitek_02_HowAreYouFeeling_7.9c4da982.mp3";